import { H } from 'highlight.run';
import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import type { AuthContextType } from '../../types/auth';

const Highlight = () => {
  const { user } = useAuth() as AuthContextType;
  const envTier = import.meta.env.VITE_ENV_TIER as string;
  const projectId = 'jd40q0wg'
  const serviceName = 'hangjam'
  
  useEffect(() => {
    // Skip Highlight operations in development
    if (envTier === 'dev') {
      return;
    }
    
    // Initialize Highlight only once
    H.init(projectId, {
      serviceName: serviceName,
      environment: envTier,
      tracingOrigins: true,
      networkRecording: {
        enabled: true,
        recordHeadersAndBody: true,
        urlBlocklist: [],
      },
    });
  }, []); // Empty deps array ensures this runs exactly once

  // Handle user identification separately
  useEffect(() => {
    if (envTier === 'dev' || !user?.id) {
      return;
    }
    H.identify(user.id);
  }, [user]); // Only depends on user changes

  return null;
};

export default Highlight;
